import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';

@Component({
  selector: 'piqet-angular-dropdown-scenario-config',
  templateUrl: './dropdown-scenario-config.component.html',
  styleUrls: ['./dropdown-scenario-config.component.css'],
})
export class DropdownScenarioConfigComponent {
  scenarioConfigList: any;
  params: any;
  scenarioId: any;

  constructor(private projectService: ProjectsService, private route: ActivatedRoute) {
    this.scenarioConfigList = [
      { description: 'g' },
      { description: 'kg/l' },
      { description: 'FU/unit' },
    ];
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
  }
}
